import { render, staticRenderFns } from "./QnaMgmtForm.vue?vue&type=template&id=138bce62&"
import script from "./QnaMgmtForm.vue?vue&type=script&lang=js&"
export * from "./QnaMgmtForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports